import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
// import ImageUploading from "react-images-uploading";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import SelectDropdown from "../components-react/SelectDropdown";
import {
  getCurrentTimeOption,
  leadCustomerCategories,
  leadPlanTypes,
  leadSources,
  times,
} from "../common-data/DropdowData";
import {
  convertStraight,
  currentMonthCurrentDate,
  formatDateTime,
  formatExtractDateTime,
} from "../common-data/Converts";
import { showConfirmAlert } from "../components-react/ReactAlert";
import {
  commonPostPutApi,
  fetchApiData,
} from "../../redux/reducers/commonApiSlice";
import { addLead, addLeadFollowup } from "../../data/ApiEndpoints";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { validLeadAddFormValues } from "./functions/LeadValidations";
import {
  fetchLeadSourceData,
  fetchReceptionistBySlotData,
} from "../../redux/reducers/dropdownApiSlice";
import { fetchGymData } from "../../data/APIs";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import {
  fetchCustomerIntentData,
  fetchFollowupStatusData,
} from "../../redux/reducers/apiSlice";
import { uploadImage } from "../../redux/reducers/postApiSlice";
import "../../styles/lead-mangement/lead-form.css";

const AddLeadForm = ({
  userInfoData,
  closeModal,
  callFunction,
  rowData,
  isRawLead,
  isUnassignedRawLead,
  isURE,
  ureCard,
  isODM,
  odmSource,
  isBTL,
  isRecurring999,
  clickedCard,
  isWalkin,
  isUntrackedWatiLead,
  isFreshLead,
  isPreSaleLead,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { receptionistBySlot, leadSources: dynamic_lead_sources } = useSelector(
    (state) => state.dropdown
  );
  const { postPutLoading } = useSelector((state) => state.common);
  const { customerIntentCategory, followupStatuses } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isAutoFillData =
    isUnassignedRawLead ||
    isURE ||
    isODM ||
    isBTL ||
    isRecurring999 ||
    isWalkin ||
    isFreshLead ||
    isPreSaleLead;

  const [customerIntents, setCustomerIntents] = useState([]);
  const [followupStatus, setFollowupStatus] = useState([]);
  const iniTimeOptions = {
    firstFollowupTimeOptions: [],
    nextFollowupTimeOptions: [],
  };
  const [timesOption, setTimesOption] = useState(iniTimeOptions);

  const getInitialFormValues = () => {
    const baseValues = {
      addedById:
        isAutoFillData && rowData?.added_by_id
          ? rowData.added_by_id
          : rowData?.sub_added_by
          ? rowData?.sub_added_by
          : userInfoData?.uid || userInfoData?.user_id || "",
      custName: isAutoFillData
        ? rowData?.name || rowData?.user_name || ""
        : rowData?.user_name
        ? rowData.user_name
        : "",
      custMobile: isAutoFillData
        ? rowData?.mobile || rowData?.user_mobile || ""
        : rowData?.user_mobile
        ? rowData.user_mobile
        : "",
      custEmail: isAutoFillData
        ? rowData?.email || rowData?.user_email || ""
        : rowData?.user_email
        ? rowData.user_email
        : "",
      defaultGym:
        rowData?.gym_id && rowData?.gym_name
          ? { label: rowData.gym_name, value: rowData.gym_id }
          : !isAdmin
          ? {
              label: userInfoData?.gym_name,
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : "",
      selectedGym:
        rowData?.gym_id && rowData?.gym_name
          ? { label: rowData.gym_name, value: rowData.gym_id }
          : !isAdmin
          ? {
              label: userInfoData?.gym_name,
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : "",
      selectedSource:
        (isUnassignedRawLead || isODM || isBTL || isRecurring999 || isWalkin) &&
        rowData?.source_name
          ? {
              label: rowData.source_name?.replace(/_/g, " "),
              value: rowData.source_name,
            }
          : isURE
          ? {
              label: ureCard === "unpaid" ? "Unpaid" : "Renewal",
              value: ureCard === "unpaid" ? "unpaid" : "renewal",
            }
          : isODM
          ? {
              label: "WTF One Day Membership",
              value: "wtf_one_day_plan",
            }
          : isPreSaleLead
          ? {
              label: "Pre Sale",
              value: "pre_sale",
            }
          : clickedCard === "referral"
          ? {
              label: "Website Referral",
              value: "website_referral",
            }
          : clickedCard === "wati_leads"
          ? {
              label: "Wati",
              value: "wati",
            }
          : "",
      selCustomerIntent:
        ((isUnassignedRawLead &&
          (clickedCard === "referral" || clickedCard === "wati_leads")) ||
          isRawLead ||
          isURE ||
          isODM ||
          isBTL ||
          isRecurring999 ||
          isWalkin ||
          isPreSaleLead) &&
        customerIntents.find((int) => int.label?.toLowerCase() === "interested")
          ? customerIntents.find(
              (int) => int.label?.toLowerCase() === "interested"
            )
          : "",
      selectedPlan:
        rowData?.plan_name &&
        leadPlanTypes.find((plan) =>
          rowData?.plan_name?.toLowerCase()?.includes(plan.value)
        )
          ? leadPlanTypes.find((plan) =>
              rowData.plan_name?.toLowerCase()?.includes(plan.value)
            ) || ""
          : rowData?.plan_name
          ? {
              label: rowData.plan_name?.replace(/_/g, " "),
              value: rowData.plan_name?.replace(/\s+/g, "_").toLowerCase(),
            }
          : rowData?.type
          ? {
              label: rowData.type?.replace(/_/g, " "),
              value: rowData.type?.replace(/\s+/g, "_").toLowerCase(),
            }
          : "",
      leadValueAmount:
        isURE && rowData?.price
          ? rowData.price
          : rowData?.total_amount
          ? rowData.total_amount
          : 0,
      leadType: "",
      // For "Customer Not In LMS But Paid" flow (isRawLead) the customer has
      // ALREADY paid — default to "converted" instead of "payment_link_sent"
      // so the Next Followup Date field auto-hides and Submit goes through
      // without demanding a future followup for an already-converted lead.
      selectedFirstFollowupStatus:
        isRawLead &&
        followupStatus.find((int) => int.value === "converted")
          ? followupStatus.find((int) => int.value === "converted")
          : isURE && followupStatus.find((int) => int.value === "renewal")
          ? followupStatus.find((int) => int.value === "renewal")
          : isODM &&
            followupStatus.find((int) => int.value === "wtf_one_day_plan")
          ? followupStatus.find((int) => int.value === "wtf_one_day_plan")
          : "",
      firstFollowupDate: rowData?.subscription_added
        ? convertStraight(
            formatExtractDateTime(rowData.subscription_added).formattedDate
          )
        : convertStraight(currentMonthCurrentDate),
      firstFollowupTime: rowData?.subscription_added
        ? {
            label: formatExtractDateTime(rowData.subscription_added)
              .formattedTime12,
            value: formatExtractDateTime(rowData.subscription_added)
              .formattedTime24,
          }
        : "",
      nextFollowupDate: "",
      nextFollowupTime: "",
      expectedCloserDate: rowData?.subscription_added
        ? formatExtractDateTime(rowData.subscription_added).formattedDate
        : "",
      selectedReceptionist: "",
      firstFollowupDetails: isRawLead
        ? `Customer has already paid for ${
            rowData?.plan_name || ""
          } and is being added to LMS as a converted lead.`
        : "",
      isAssignDifferentReceptionist: isRawLead ? false : isAdmin ? true : false,
      isSelfAssign: false,
      whatsappVerificationImg: rowData?.wap_image || "",
    };

    return baseValues;
  };

  const iniFormValues = getInitialFormValues();
  const [formValues, setFormValues] = useState(iniFormValues);
  const imgVdoInitials = {
    whatsappVerificationImg: rowData?.wap_image
      ? [{ data_url: rowData.wap_image }]
      : [],
  };
  const [formImages, setFormImages] = useState(imgVdoInitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [leadLookupStep, setLeadLookupStep] = useState("mobile_input");
  const [leadLookupData, setLeadLookupData] = useState(null);
  const [isLookupLoading, setIsLookupLoading] = useState(false);
  const [transferConfirmed, setTransferConfirmed] = useState(false);

  // Fix: do NOT gate on !isRawLead. The validation (LeadValidations.js) requires
  // nextFollowupDate/Time whenever the selected status has next_followup_required=1,
  // regardless of isRawLead. Previously this gated rendering on !isRawLead, so for
  // raw-lead flows (e.g. "Customer Not In LMS But Paid" → Add To LMS) the field
  // was hidden but still required → Submit failed silently with no API call.
  const is_Next_Followup_Required_Raw =
    formValues.selectedFirstFollowupStatus &&
    formValues.selectedFirstFollowupStatus?.next_followup_required;
  // const is_Next_Followup_Required =
  //   formValues.selectedFirstFollowupStatus &&
  //   formValues.selectedFirstFollowupStatus?.next_followup_required;
  const is_Plan_Info_Required =
    formValues.selectedFirstFollowupStatus &&
    formValues.selectedFirstFollowupStatus?.price_required;
  const isSourceNameNotRequired =
    (isURE ||
      isODM ||
      isUnassignedRawLead ||
      isBTL ||
      isRecurring999 ||
      isWalkin ||
      isPreSaleLead) &&
    formValues.selectedSource;
  const isCustomerIntentNotRequired =
    (isODM ||
      isRawLead ||
      isBTL ||
      isRecurring999 ||
      isWalkin ||
      isPreSaleLead ||
      (isUnassignedRawLead &&
        (clickedCard === "referral" || clickedCard === "wati_leads"))) &&
    formValues.selCustomerIntent;
  const isFirstFollowupstatusNotRequired =
    isRawLead && formValues.selectedFirstFollowupStatus;
  // const isFirstFollowupRemarksNotRequired =
  //   (isODM || isRawLead) && formValues.firstFollowupDetails;
  // const isMobileNotRequired =
  //   (isODM ||
  //     isRawLead ||
  //     isBTL ||
  //     isRecurring999 ||
  //     isWalkin ||
  //     (isUnassignedRawLead &&
  //       (clickedCard === "referral" || clickedCard === "wati_leads"))) &&
  //   formValues.custMobile;
  // const isWpImageRequired =
  //   formValues.selectedFirstFollowupStatus &&
  //   formValues.selectedFirstFollowupStatus?.info?.wap_verification;

  const formRef = useRef({});

  const assignRef = (fieldName) => (el) => {
    if (!formRef.current) {
      formRef.current = {};
    }
    if (el) {
      formRef.current[fieldName] = el;
    }
  };

  function getReceptionistBySlot(filter) {
    dispatch(
      fetchReceptionistBySlotData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  function getCustomerIntent(filters) {
    dispatch(
      fetchCustomerIntentData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getFollowupStatuses(filters) {
    dispatch(
      fetchFollowupStatusData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getLeadSources(filters) {
    dispatch(
      fetchLeadSourceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "nextFollowupDate") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        expectedCloserDate: value,
        nextFollowupTime: "",
      }));
    } else if (name === "custMobile" && value.length > 10) {
      return;
    } else if (name === "isSelfAssign") {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: checked,
        selectedReceptionist: checked ? "" : prevs.selectedReceptionist,
        isAssignDifferentReceptionist: checked
          ? false
          : prevs.isAssignDifferentReceptionist,
      }));
    } else if (name === "isAssignDifferentReceptionist") {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: checked,
        isSelfAssign: checked ? false : prevs.isSelfAssign,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selectedGym") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedReceptionist: "",
      }));
    } else if (name === "selCustomerIntent") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedFirstFollowupStatus: "",
        selectedPlan: "",
        leadValueAmount: "",
        expectedCloserDate: "",
      }));
      setFollowupStatus([]);
    } else if (name === "selectedFirstFollowupStatus") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        whatsappVerificationImg: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onChangeImages = (imageList, name) => {
    setIsSubmit(false);

    setFormImages((prevImages) => ({
      ...prevImages,
      [name]: imageList,
    }));

    if (imageList.length > 0) {
      imageList.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "filename.jpeg", { type: "image/jpeg" });

        handleUploadImage(file, userInfoData?.token, name);
      });
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: "",
      }));
    }
  };

  const handleUploadImage = async (file, TOKEN, name) => {
    setIsSubmit(false);
    try {
      const actionResult = dispatch(uploadImage({ file, TOKEN }));
      const result = await actionResult;

      console.log("result=> ", result);

      if (result?.payload?.status) {
        setFormValues((prevs) => ({
          ...prevs,
          [name]:
            result?.payload?.image_url || result?.payload?.data?.url || "",
        }));
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreateNewMeal ERROR => ", error);
    }
  };

  const handleFetchLeadDetails = async () => {
    if (!formValues.custMobile || formValues.custMobile.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsLookupLoading(true);
    setLeadLookupStep("fetching");
    // setLeadLookupStep("show_form");

    try {
      const result = await dispatch(
        fetchApiData({
          method: "GET",
          endpoint: "/leads/lead-owner",
          payload: {
            filters: { mobile: formValues.custMobile },
          },
          token: userInfoData?.token,
        })
      );

      setIsLookupLoading(false);

      if (result?.payload?.status === false && !result?.payload?.is_exist) {
        setLeadLookupStep("show_form");
        setLeadLookupData(null);
      } else if (result?.payload?.is_exist && result?.payload?.is_converted) {
        setLeadLookupStep("show_converted");
        setLeadLookupData(result.payload.data[0]);
      } else if (result?.payload?.status && result?.payload?.data?.length > 0) {
        const currentUserId = result.payload.data[0].assigned_to;
        const assignedTo = userInfoData?.uid || userInfoData?.user_id;

        if (assignedTo === currentUserId) {
          setLeadLookupStep("show_existing");
          setLeadLookupData(result.payload.data[0]);
        } else {
          setLeadLookupStep("show_transfer");
          setLeadLookupData(result.payload.data[0]);
        }
      }
    } catch (error) {
      setIsLookupLoading(false);
      setLeadLookupStep("show_form");
      console.error("Error fetching lead details:", error);
      toast.error(
        "Error fetching lead details. Proceeding with new lead form."
      );
    }
  };

  const handleConfirmTransfer = () => {
    const handleConfirm = async () => {
      setTransferConfirmed(true);
      // setLeadLookupStep("show_followup_form");
      setLeadLookupStep("show_form");
      setFormValues(autoFillFormData(leadLookupData));
    };

    showConfirmAlert(
      handleConfirm,
      `This ${formValues.custMobile || ""} number already assigned to ${
        leadLookupData?.name || "another user"
      }. Do you want to transfer the lead to your account - ${
        userInfoData?.name || ""
      }?`,
      "No, Cancel",
      "Yes, Transfer"
    );
  };

  const autoFillFormData = (data) => {
    const currentTimeStamp = getCurrentTimeOption();

    return {
      ...iniFormValues,
      custName: data?.name || data?.user_name || "",
      custMobile: formValues.custMobile || "",
      custEmail: data?.email || data?.user_email || "",
      selectedSource: data?.source_name
        ? {
            label: data.source_name.replace(/_/g, " "),
            value: data.source_name,
          }
        : "",
      selectedPlan: data?.plan_name
        ? {
            label: data.plan_name.replace(/_/g, " "),
            value: data.plan_name.replace(/\s+/g, "_").toLowerCase(),
          }
        : "",
      leadValueAmount: data?.total_amount || data?.price || 0,
      firstFollowupDetails: data?.remarks || "",
      selectedGym:
        data?.gym_id && data?.gym_name
          ? {
              label: data.gym_name,
              value: data.gym_id,
            }
          : "",
      defaultGym:
        data?.gym_id && data?.gym_name
          ? {
              label: data.gym_name,
              value: data.gym_id,
            }
          : "",
      firstFollowupTime: currentTimeStamp,
    };
  };

  const handleReopenLead = () => {
    setLeadLookupStep("show_form");
    // setFormValues((prev) => ({
    //   ...iniFormValues,
    //   custName: leadLookupData?.name || "",
    //   custMobile: leadLookupData?.mobile || "",
    //   custEmail: leadLookupData?.email || "",
    //   selectedSource: leadLookupData?.source_name
    //     ? {
    //         label: leadLookupData.source_name.replace(/_/g, " "),
    //         value: leadLookupData.source_name,
    //       }
    //     : "",
    // }));
    setFormValues(autoFillFormData(leadLookupData));
  };

  const handleTryDifferentNumber = () => {
    setLeadLookupStep("mobile_input");
    // setFormValues(iniFormValues);
    setFormValues(getInitialFormValues());
    setLeadLookupData(null);
    setTransferConfirmed(false);
  };

  const buildFollowupPayload = (leadId) => {
    return {
      lead_id: leadId,
      duration: formValues.selectedPlan?.value || "",
      lead_value: formValues.leadValueAmount || 0,
      followUpDetails: [
        {
          added_by: formValues.addedById,
          customer_intent_id: formValues.selCustomerIntent?.value || "",
          follow_up_status: formValues.selectedFirstFollowupStatus?.value,
          scheduled_on: "",
          next_follow_up_date:
            formValues.nextFollowupDate && formValues.nextFollowupTime?.value
              ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
              : "",
          remarks: formValues.firstFollowupDetails,
          is_first: 1,
        },
        {
          added_by: formValues.addedById,
          follow_up_status: "pending",
          scheduled_on:
            formValues.nextFollowupDate && formValues.nextFollowupTime?.value
              ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
              : "",
          next_follow_up_date: "",
          remarks: "",
        },
      ],
    };
  };

  const handleAddLeadFolowup = async (leadId) => {
    const payload = buildFollowupPayload(leadId);

    const method = "POST";
    const endpoint = addLeadFollowup;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(iniFormValues);
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleAddLead = async (payload, skipFollowup = false) => {
    const method = "POST";
    const endpoint = addLead;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        // Only call handleAddLeadFolowup if not explicitly skipped
        if (!skipFollowup) {
          await handleAddLeadFolowup(result?.payload?.data?.lead_id || "");
        }
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
        return result;
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
        return result;
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      return null;
    }
    // try {
    //   const result = await dispatch(
    //     commonPostPutApi({ method, endpoint, payload, token })
    //   );

    //   if (result?.payload?.status) {
    //     handleAddLeadFolowup(result?.payload?.data?.lead_id || "");
    //     setIsSubmit(false);
    //     closeModal();
    //     callFunction();
    //     toast.success(result?.payload?.message || "Success!");
    //   } else {
    //     const errorMessage = result?.payload?.message || result?.error?.message;
    //     toast.error(errorMessage || "Something Went Wrong!");
    //   }
    // } catch (error) {
    //   console.error("Error making POST request:", error);
    // }
  };

  const handleTransferLead = async (transferPayload) => {
    const method = "POST";
    const endpoint = "/leads/transfer-lead";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload: transferPayload, token })
      );

      if (result?.payload?.status) {
        // After transfer, call handleAddLead and then handleAddLeadFolowup
        const userData = buildLeadPayload();
        const addLeadResult = await handleAddLead(userData, true); // Skip followup in handleAddLead
        if (addLeadResult?.payload?.status) {
          await handleAddLeadFolowup(
            addLeadResult?.payload?.data?.lead_id || ""
          );
        }
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(
          result?.payload?.message || "Lead transferred successfully!"
        );
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const checkLeadOwnershipAndProceed = async (userData) => {
    try {
      const result = await dispatch(
        fetchApiData({
          method: "GET",
          endpoint: "/leads/lead-owner",
          payload: {
            filters: { mobile: formValues.custMobile },
          },
          token: userInfoData?.token,
        })
      );

      if (result?.payload?.status && result?.payload?.data?.length > 0) {
        const currentUserId = result.payload.data[0].assigned_to;
        const assignedTo = userInfoData?.uid || userInfoData?.user_id;

        if (assignedTo !== currentUserId) {
          const transferPayload = {
            transferred_from: currentUserId,
            transferred_to: assignedTo,
            gym_id: userData.gym_id,
            lead_id: result.payload.data[0].lead_id || "",
          };

          const handleConfirm = async () => {
            await handleTransferLead(transferPayload);
          };

          showConfirmAlert(
            handleConfirm,
            `This ${formValues.custMobile || ""} number already assigned to ${
              result.payload.data[0].name
            }. Do you want to transfer the lead to your account - ${
              userInfoData?.name || ""
            }?`,
            "No, Cancel",
            "Yes, Submit"
          );

          return;
        }
      }

      // If no transfer needed, proceed with normal flow
      const handleConfirm = async () => {
        await handleAddLead(userData);
      };

      showConfirmAlert(
        handleConfirm,
        "You are about to add a new lead. Please confirm that all details are correct. Do you want to proceed?",
        "No, Cancel",
        "Yes, Submit"
      );
    } catch (error) {
      console.error("Error checking lead ownership:", error);

      const handleConfirm = async () => {
        await handleAddLead(userData);
      };

      showConfirmAlert(
        handleConfirm,
        "You are about to add a new lead. Please confirm that all details are correct. Do you want to proceed?",
        "No, Cancel",
        "Yes, Submit"
      );
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    if (leadLookupStep === "show_form" && transferConfirmed) {
      const errors = validLeadAddFormValues(formValues, isRawLead, false);
      setFormErrors(errors);
      setIsSubmit(true);

      if (Object.keys(errors).length === 0) {
        setIsSubmit(true); // This will trigger the useEffect below
      } else if (formRef.current && Object.keys(errors).length > 0) {
        const firstErrorField = Object.keys(errors).find(
          (field) => formRef.current[field]
        );

        if (firstErrorField) {
          formRef.current[firstErrorField].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    } else if (leadLookupStep === "show_form" && leadLookupData) {
      const errors = validLeadAddFormValues(formValues, isRawLead, false);
      setFormErrors(errors);
      setIsSubmit(true);

      if (Object.keys(errors).length === 0) {
        setIsSubmit(true);
      } else if (formRef.current && Object.keys(errors).length > 0) {
        const firstErrorField = Object.keys(errors).find(
          (field) => formRef.current[field]
        );

        if (firstErrorField) {
          formRef.current[firstErrorField].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    } else {
      const errors = validLeadAddFormValues(formValues, isRawLead, false);
      setFormErrors(errors);
      setIsSubmit(true);

      if (formRef.current && Object.keys(errors).length > 0) {
        const firstErrorField = Object.keys(errors).find(
          (field) => formRef.current[field]
        );

        if (firstErrorField) {
          formRef.current[firstErrorField].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }
  };

  useEffect(() => {
    if (isRawLead && rowData) {
      setFormValues((prevs) => ({
        ...prevs,
        addedById: rowData?.sub_added_by ? rowData?.sub_added_by : "",
        custName: rowData?.user_name ? rowData.user_name : "",
        custMobile: rowData?.user_mobile ? rowData.user_mobile : "",
        custEmail: rowData?.user_email ? rowData.user_email : "",
        defaultGym:
          rowData?.gym_id && rowData?.gym_name
            ? { label: rowData.gym_name, value: rowData.gym_id }
            : !isAdmin
            ? {
                label: userInfoData?.gym_name,
                value:
                  userInfoData?.gym_id ||
                  userInfoData?.user_id ||
                  userInfoData?.uid ||
                  "",
              }
            : "",
        selectedGym:
          rowData?.gym_id && rowData?.gym_name
            ? { label: rowData.gym_name, value: rowData.gym_id }
            : !isAdmin
            ? {
                label: userInfoData?.gym_name,
                value:
                  userInfoData?.gym_id ||
                  userInfoData?.user_id ||
                  userInfoData?.uid ||
                  "",
              }
            : "",
        selCustomerIntent:
          isRawLead &&
          customerIntents.find(
            (int) => int.label?.toLowerCase() === "interested"
          )
            ? customerIntents.find(
                (int) => int.label?.toLowerCase() === "interested"
              )
            : "",
        selectedPlan:
          rowData?.plan_name &&
          leadPlanTypes.find((plan) =>
            rowData?.plan_name?.toLowerCase()?.includes(plan.value)
          )
            ? leadPlanTypes.find((plan) =>
                rowData.plan_name?.toLowerCase()?.includes(plan.value)
              ) || ""
            : rowData?.plan_name
            ? {
                label: rowData.plan_name?.replace(/_/g, " "),
                value: rowData.plan_name?.replace(/\s+/g, "_").toLowerCase(),
              }
            : rowData?.type
            ? {
                label: rowData.type?.replace(/_/g, " "),
                value: rowData.type?.replace(/\s+/g, "_").toLowerCase(),
              }
            : "",
        leadValueAmount: rowData?.total_amount ? rowData.total_amount : 0,
        // For "Customer Not In LMS But Paid" flow the customer has ALREADY
        // paid — defaulting to "payment_link_sent" was misleading and forced a
        // next-followup-date field that has no meaning for a converted lead.
        // Default to "converted" instead: next_followup_required=0 and
        // price_required=0 in customer_intent_value, so Submit goes through
        // cleanly without demanding a future followup date.
        selectedFirstFollowupStatus:
          isRawLead && followupStatus.find((int) => int.value === "converted")
            ? followupStatus.find((int) => int.value === "converted")
            : "",
        firstFollowupDate: rowData?.subscription_added
          ? convertStraight(
              formatExtractDateTime(rowData.subscription_added).formattedDate
            )
          : convertStraight(currentMonthCurrentDate),
        firstFollowupTime: rowData?.subscription_added
          ? {
              label: formatExtractDateTime(rowData.subscription_added)
                .formattedTime12,
              value: formatExtractDateTime(rowData.subscription_added)
                .formattedTime24,
            }
          : getCurrentTimeOption(),
        expectedCloserDate: rowData?.subscription_added
          ? formatExtractDateTime(rowData.subscription_added).formattedDate
          : "",
        firstFollowupDetails: isRawLead
          ? `Customer has already paid for ${
              rowData?.plan_name || ""
            } and is being added to LMS as a converted lead.`
          : "",
        isAssignDifferentReceptionist: isRawLead
          ? false
          : isAdmin
          ? true
          : false,
      }));
    }
  }, [customerIntents, followupStatus, leadPlanTypes]);

  useEffect(() => {
    if ((isURE || isODM || isBTL || isRecurring999 || isWalkin) && rowData) {
      setFormValues((prevs) => ({
        ...prevs,
        addedById:
          isURE && rowData?.added_by_id
            ? rowData.added_by_id
            : rowData?.sub_added_by
            ? rowData?.sub_added_by
            : "",
        custName: rowData?.name || rowData?.user_name || "",
        custMobile: rowData?.mobile || rowData?.user_mobile || "",
        custEmail: rowData?.email || rowData?.user_email || "",
        defaultGym:
          rowData?.gym_id && rowData?.gym_name
            ? { label: rowData.gym_name, value: rowData.gym_id }
            : !isAdmin
            ? {
                label: userInfoData?.gym_name,
                value:
                  userInfoData?.gym_id ||
                  userInfoData?.user_id ||
                  userInfoData?.uid ||
                  "",
              }
            : "",
        selectedGym:
          rowData?.gym_id && rowData?.gym_name
            ? { label: rowData.gym_name, value: rowData.gym_id }
            : !isAdmin
            ? {
                label: userInfoData?.gym_name,
                value:
                  userInfoData?.gym_id ||
                  userInfoData?.user_id ||
                  userInfoData?.uid ||
                  "",
              }
            : "",
        selectedSource: isURE
          ? {
              label: ureCard === "unpaid" ? "Unpaid" : "Renewal",
              value: ureCard === "unpaid" ? "unpaid" : "renewal",
            }
          : isODM
          ? {
              label: "WTF One Day Membership",
              value: "wtf_one_day_plan",
            }
          : rowData?.source_name
          ? {
              label: rowData.source_name?.replace(/_/g, " "),
              value: rowData.source_name,
            }
          : clickedCard === "referral"
          ? {
              label: "Website Referral",
              value: "website_referral",
            }
          : clickedCard === "wati_leads"
          ? {
              label: "Wati",
              value: "wati",
            }
          : "",
        selectedPlan:
          rowData?.plan_name &&
          leadPlanTypes.find((plan) =>
            rowData?.plan_name?.toLowerCase()?.includes(plan.value)
          )
            ? leadPlanTypes.find((plan) =>
                rowData.plan_name?.toLowerCase()?.includes(plan.value)
              ) || ""
            : rowData?.plan_name
            ? {
                label: rowData.plan_name?.replace(/_/g, " "),
                value: rowData.plan_name?.replace(/\s+/g, "_").toLowerCase(),
              }
            : rowData?.type
            ? {
                label: rowData.type?.replace(/_/g, " "),
                value: rowData.type?.replace(/\s+/g, "_").toLowerCase(),
              }
            : "",
        leadValueAmount: isURE && rowData?.price ? rowData.price : 0,
      }));
    }
  }, [isURE, isODM, isBTL, isRecurring999, isWalkin]);

  useEffect(() => {
    if (
      ((isUnassignedRawLead &&
        (clickedCard === "referral" || clickedCard === "wati_leads")) ||
        isURE ||
        isODM ||
        isBTL ||
        isRecurring999 ||
        isWalkin ||
        isPreSaleLead) &&
      rowData &&
      customerIntents?.length > 0
    ) {
      setFormValues((prevs) => ({
        ...prevs,
        selCustomerIntent: customerIntents.find(
          (int) => int.label?.toLowerCase() === "interested"
        )
          ? customerIntents.find(
              (int) => int.label?.toLowerCase() === "interested"
            )
          : "",
      }));
    }
  }, [customerIntents]);

  useEffect(() => {
    if (
      (isURE || isODM) &&
      rowData &&
      formValues.selCustomerIntent &&
      followupStatus?.length > 0
    ) {
      setFormValues((prevs) => ({
        ...prevs,
        selectedFirstFollowupStatus:
          isURE && followupStatus.find((int) => int.value === "renewal")
            ? followupStatus.find((int) => int.value === "renewal")
            : isODM &&
              followupStatus.find((int) => int.value === "wtf_one_day_plan")
            ? followupStatus.find((int) => int.value === "wtf_one_day_plan")
            : "",
      }));
    }
  }, [formValues.selCustomerIntent, followupStatus]);

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 10,
      status: "active",
    };

    getCustomerIntent(filters);
  }, []);

  useEffect(() => {
    if (formValues.selCustomerIntent?.value) {
      const filters = {
        page: 1,
        limit: 200,
        status: "active",
        intent_id: formValues.selCustomerIntent.value,
      };

      getFollowupStatuses(filters);
    }
  }, [formValues.selCustomerIntent]);

  useEffect(() => {
    const filters = {
      limit: 2000,
      page: 1,
      is_rawlead: 0,
    };

    getLeadSources(filters);
  }, []);

  useEffect(() => {
    if (formValues.nextFollowupDate) {
      const today = new Date();

      const selectedDate = new Date(formValues.nextFollowupDate);
      const currentHour = today.getHours();
      const currentMinute = today.getMinutes();
      if (selectedDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
        const filteredTimes = times.filter((time) => {
          const timeStr = time.value.split(":");
          const timeHour = parseInt(timeStr[0]);
          const timeMinute = parseInt(timeStr[1]);
          return (
            timeHour > currentHour ||
            (timeHour === currentHour && timeMinute >= currentMinute)
          );
        });

        setTimesOption((prevs) => ({
          ...prevs,
          nextFollowupTimeOptions: filteredTimes,
        }));
      } else {
        setTimesOption((prevs) => ({
          ...prevs,
          nextFollowupTimeOptions: times,
        }));
      }
    }
  }, [formValues.nextFollowupDate]);

  useEffect(() => {
    if (formValues.nextFollowupDate) {
      const today = new Date();
      const nextFollowup = new Date(formValues.nextFollowupDate);
      const differenceInDays = Math.floor(
        (nextFollowup - today) / (1000 * 60 * 60 * 24)
      );

      let selectedLeadType = "";

      if (differenceInDays === -1) {
        selectedLeadType = "hot";
      } else if (differenceInDays === 0) {
        selectedLeadType = "semi_hot";
      } else if (differenceInDays === 1) {
        selectedLeadType = "warm";
      } else {
        selectedLeadType = "cold";
      }

      const selectedLeadCategory = leadCustomerCategories.find(
        (category) => category.value === selectedLeadType
      );

      if (selectedLeadCategory) {
        setFormValues((prevs) => ({
          ...prevs,
          leadType: selectedLeadCategory,
        }));
      }
    }
  }, [formValues.nextFollowupDate]);

  useEffect(() => {
    const currentTime = new Date();
    const currentHours = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();
    const currentTimeStr = `${
      currentHours < 10 ? "0" + currentHours : currentHours
    }:${currentMinutes < 10 ? "0" + currentMinutes : currentMinutes}`;

    const filteredTimes = times.filter((time) => time.value < currentTimeStr);
    setTimesOption((prevs) => ({
      ...prevs,
      firstFollowupTimeOptions: filteredTimes,
    }));
  }, []);

  useEffect(() => {
    if (!formValues.isSelfAssign) {
      const filters = {
        gym_id:
          formValues.selectedGym?.value || formValues.defaultGym?.value || "",
        slot_start_time: formValues.nextFollowupTime?.value || "",
        slot_end_time: formValues.nextFollowupTime?.value || "",
      };

      getReceptionistBySlot(filters);
    }
  }, [
    formValues.nextFollowupTime,
    formValues.isAssignDifferentReceptionist,
    formValues.selectedGym,
    formValues.isSelfAssign,
  ]);

  useEffect(() => {
    const currentTimeStamp = getCurrentTimeOption();

    setFormValues((prevs) => ({
      ...prevs,
      firstFollowupTime: currentTimeStamp,
    }));
  }, []);

  useEffect(() => {
    if (formValues.isAssignDifferentReceptionist || isAdmin) {
      dispatch(fetchGymData(userInfoData?.token));
    }
  }, [formValues.isAssignDifferentReceptionist]);

  useEffect(() => {
    if (
      customerIntentCategory?.status &&
      customerIntentCategory?.data?.length > 0
    ) {
      const allIntents = customerIntentCategory?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name?.replace(/_/g, " ") || "",
        next_followup_required: item?.next_followup_required || 0,
      }));

      setCustomerIntents(allIntents);
    } else {
      setCustomerIntents([]);
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (followupStatuses?.status && followupStatuses?.data?.length > 0) {
      const allFollowups = followupStatuses?.data?.map((item) => ({
        value: item?.value || "",
        label: item?.display_label || "",
        next_followup_required: item?.next_followup_required || false,
        price_required: item?.price_required || 0,
        info: item || {},
      }));

      setFollowupStatus(allFollowups);
    } else {
      setFollowupStatus([]);
    }
  }, [followupStatuses]);

  const buildLeadPayload = () => {
    const isNotInterested =
      formValues.selCustomerIntent &&
      formValues.selCustomerIntent?.label?.toLowerCase() === "not interested";

    return {
      name: formValues.custName,
      mobile: formValues.custMobile,
      email: formValues.custEmail || "",
      plan_type: formValues.selectedPlan?.value || "",
      lead_value: formValues.leadValueAmount || 0,
      duration: formValues.selectedPlan?.value || "",
      expected_closure_date: formValues.nextFollowupDate || "",
      source_name: formValues.selectedSource?.value,
      lead_type: formValues.leadType?.value,
      lead_status: isRawLead ? "converted" : "pending",
      gym_id:
        formValues.selCustomerIntent && isNotInterested
          ? formValues.defaultGym?.value || ""
          : formValues.isAssignDifferentReceptionist || formValues.isSelfAssign
          ? formValues.selectedGym?.value
          : formValues.defaultGym?.value,
      next_folloup_date:
        formValues.nextFollowupDate && formValues.nextFollowupTime?.value
          ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
          : "",
      current_followup_status: isRawLead
        ? formValues.selectedFirstFollowupStatus?.value || ""
        : "pending",
      assigned_to:
        (formValues.selCustomerIntent && isNotInterested) ||
        formValues.isSelfAssign
          ? userInfoData?.user_id || userInfoData?.uid
          : formValues.isAssignDifferentReceptionist
          ? formValues.selectedReceptionist?.value
          : userInfoData?.uid || userInfoData?.user_id,
      customer_intent_id: formValues.selCustomerIntent?.value || "",
      raw_lead: isRawLead ? 1 : 0,
      raw_lead_id:
        isUnassignedRawLead && clickedCard !== "referral" && rowData?.uid
          ? rowData.uid
          : "",
      lead_from: isRawLead
        ? "raw_lead"
        : isURE && ureCard
        ? ureCard
        : isODM && odmSource
        ? odmSource
        : isODM && !odmSource
        ? "one_day_membership"
        : isBTL
        ? "btl_marketting"
        : clickedCard === "referral"
        ? "website_referral"
        : isRecurring999
        ? "tripple_nine"
        : clickedCard === "referral"
        ? "wati"
        : isWalkin
        ? "walkin"
        : isPreSaleLead
        ? "pre_sale"
        : "lms",
      is_odm_lead: isODM ? 1 : "",
      odm_lead_id: isODM ? rowData?.uid : "",
      is_btl_lead: isBTL ? 1 : "",
      btl_lead_id: isBTL ? rowData?.uid : "",
      is_tn_lead: isRecurring999 ? 1 : "",
      tn_lead_id: isRecurring999 ? rowData?.uid : "",
      wap_image: formValues.whatsappVerificationImg || "",
      is_walkin_lead: isWalkin ? 1 : 0,
      walkin_lead_id: isWalkin ? rowData?.uid : "",
      is_untr_wati_lead: isUntrackedWatiLead ? 1 : 0,
      untr_wati_lead_id: isUntrackedWatiLead ? rowData?.uid : "",
      is_fresh_lead: isFreshLead ? 1 : 0,
      fresh_lead_id: isFreshLead ? rowData?.uid : "",
      is_presale_lead: isPreSaleLead ? 1 : 0,
      presale_lead_id: isPreSaleLead ? rowData?.uid : "",
    };
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = buildLeadPayload();

      // Handle reopen case - direct call to handleAddLead → handleAddLeadFolowup
      if (
        leadLookupStep === "show_form" &&
        leadLookupData &&
        !transferConfirmed
      ) {
        const handleConfirm = async () => {
          // First call handleAddLead
          const result = await handleAddLead(userData);
          // Then call handleAddLeadFolowup with the new lead ID
          if (result?.payload?.data?.lead_id) {
            await handleAddLeadFolowup(result.payload.data.lead_id);
          }
        };

        showConfirmAlert(
          handleConfirm,
          "You are about to reopen this lead with new details. Do you want to proceed?",
          "No, Cancel",
          "Yes, Reopen Lead"
        );
        return;
      }

      // Handle transfer case - call handleTransferLead
      if (
        leadLookupStep === "show_form" &&
        leadLookupData &&
        transferConfirmed
      ) {
        const transferPayload = {
          transferred_from: leadLookupData?.assigned_to || "",
          transferred_to: userInfoData?.uid || userInfoData?.user_id,
          gym_id: userData.gym_id,
          lead_id: leadLookupData?.lead_id || "",
        };

        const handleConfirm = async () => {
          await handleTransferLead(transferPayload);
        };

        showConfirmAlert(
          handleConfirm,
          `You are about to transfer the lead "${leadLookupData?.name}" to your account and add follow-up details. Do you want to proceed?`,
          "No, Cancel",
          "Yes, Transfer & Add Follow-up"
        );
        return;
      }

      // Handle normal form submission with ownership check
      if (formValues.custMobile) {
        checkLeadOwnershipAndProceed(userData);
      } else {
        const handleConfirm = async () => {
          handleAddLead(userData);
        };

        showConfirmAlert(
          handleConfirm,
          "You are about to add a new lead. Please confirm that all details are correct. Do you want to proceed?",
          "No, Cancel",
          "Yes, Submit"
        );
      }
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);
  console.log("formValues=> ", formValues);

  return (
    <div className="lead-add-root">
      <form className="lead-add-form">
        <div className="lead-add-header" style={{ position: "relative" }}>
          <h2 className="lead-add-title">Lead Details</h2>
          <p className="lead-add-subtitle">
            {leadLookupStep === "mobile_input" || leadLookupStep === "fetching"
              ? "Enter mobile number to check existing lead"
              : leadLookupStep === "show_converted"
              ? "Lead already converted"
              : leadLookupStep === "show_existing"
              ? "Lead already exists in your account"
              : leadLookupStep === "show_transfer"
              ? "Lead transfer required"
              : leadLookupStep === "show_followup_form"
              ? "Add follow-up details"
              : leadLookupStep === "show_form" && transferConfirmed
              ? "Transfer lead to your account and add details"
              : "Please fill in the lead information below"}
          </p>
          <button
            type="button"
            className="lead-add-close-btn"
            onClick={closeModal}
            aria-label="Close"
          >
            &#10005;
          </button>
        </div>

        {leadLookupStep === "mobile_input" || leadLookupStep === "fetching" ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Mobile Number Lookup</h3>
              <p className="lead-add-section-desc">
                Enter the lead's mobile number to check for existing leads
              </p>
            </div>
            <div className="lead-add-grid">
              <div className="lead-add-field" style={{ gridColumn: "1 / -1" }}>
                <label htmlFor="custMobile" className="lead-add-label">
                  Lead Mobile <span className="lead-add-required">*</span>
                </label>
                <div className="lead-add-mobile-lookup-row">
                  <input
                    type="number"
                    placeholder="Enter 10-digit mobile number"
                    className={`lead-add-input ${
                      formErrors?.custMobile ? "lead-add-error" : ""
                    }`}
                    name="custMobile"
                    value={formValues.custMobile}
                    onChange={onChangeInput}
                    min={0}
                    disabled={leadLookupStep === "fetching"}
                  />
                  <button
                    type="button"
                    className="lead-add-fetch-btn"
                    onClick={handleFetchLeadDetails}
                    disabled={
                      leadLookupStep === "fetching" || !formValues.custMobile
                    }
                  >
                    {leadLookupStep === "fetching"
                      ? "Fetching..."
                      : "Fetch Details"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_form" ||
        leadLookupStep === "show_followup_form" ||
        leadLookupStep === "show_converted" ||
        leadLookupStep === "show_existing" ||
        leadLookupStep === "show_transfer" ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Verified Mobile Number</h3>
              <p className="lead-add-section-desc">
                Mobile number has been verified. Click "Change Number" to verify
                a different number.
              </p>
            </div>
            <div className="lead-add-grid">
              <div className="lead-add-field" style={{ gridColumn: "1 / -1" }}>
                <label htmlFor="custMobileVerified" className="lead-add-label">
                  Lead Mobile <span className="lead-add-required">*</span>
                </label>
                <div className="lead-add-mobile-lookup-row">
                  <input
                    type="text"
                    className="lead-add-input"
                    name="custMobileVerified"
                    value={`+91 ${formValues.custMobile}`}
                    disabled
                    style={{
                      background: "#f0f9ff",
                      borderColor: "#0ea5e9",
                      color: "#0369a1",
                    }}
                  />
                  <button
                    type="button"
                    className="lead-add-change-number-btn"
                    onClick={handleTryDifferentNumber}
                  >
                    Change Number
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_converted" && leadLookupData ? (
          <div className="lead-add-section">
            <div className="lead-add-notice-card lead-add-notice-error">
              <div className="lead-add-notice-icon">⚠️</div>
              <div className="lead-add-notice-content">
                <h4 className="lead-add-notice-title">
                  Lead Already Converted
                </h4>
                <p className="lead-add-notice-desc">
                  {leadLookupData.message ||
                    "This lead has an active subscription and cannot be reassigned."}
                </p>
              </div>
            </div>
            <div className="lead-add-converted-details">
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead Name:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData.name}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead Mobile:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData.mobile}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">
                  Subscription Expires:
                </span>
                <span className="lead-add-detail-value">
                  {leadLookupData?.expire_date
                    ? formatDateTime(leadLookupData.expire_date)
                    : "-"}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Status:</span>
                <span className="lead-add-detail-value lead-add-status-converted">
                  Active Subscription
                </span>
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_existing" && leadLookupData ? (
          <div className="lead-add-section">
            <div className="lead-add-notice-card lead-add-notice-info">
              <div className="lead-add-notice-icon">ℹ️</div>
              <div className="lead-add-notice-content">
                <h4 className="lead-add-notice-title">Lead Already Exists</h4>
                <p className="lead-add-notice-desc">
                  This lead was already added by you. You can add follow-ups or
                  manage the existing lead.
                </p>
              </div>
            </div>
            <div className="lead-add-converted-details">
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead Name:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData.name}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead Mobile:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData.mobile}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead ID:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData.lead_id}
                </span>
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_transfer" && leadLookupData ? (
          <div className="lead-add-section">
            <div className="lead-add-notice-card lead-add-notice-warning">
              <div className="lead-add-notice-icon">🔄</div>
              <div className="lead-add-notice-content">
                <h4 className="lead-add-notice-title">
                  Lead Transfer Required
                </h4>
                <p className="lead-add-notice-desc">
                  This lead is assigned to someone else. You can transfer it to
                  your account.
                </p>
              </div>
            </div>
            <div className="lead-add-converted-details">
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead Name:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData?.name || ""}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">Lead Mobile:</span>
                <span className="lead-add-detail-value">
                  {leadLookupData?.mobile || ""}
                </span>
              </div>
              <div className="lead-add-detail-row">
                <span className="lead-add-detail-label">
                  Currently Assigned To:
                </span>
                <span className="lead-add-detail-value">
                  {leadLookupData?.assigned_to_name || ""} (
                  {leadLookupData?.assigned_to_mobile || ""})
                </span>
              </div>
            </div>
            <div className="lead-add-transfer-actions">
              <button
                type="button"
                className="lead-add-transfer-btn"
                onClick={handleConfirmTransfer}
              >
                Transfer to My Account
              </button>
              <button
                type="button"
                className="lead-add-cancel-btn"
                onClick={handleTryDifferentNumber}
              >
                Try Different Number
              </button>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_form" ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Lead Information</h3>
              <p className="lead-add-section-desc">
                Basic details about the lead
              </p>
            </div>
            <div className="lead-add-grid">
              <div className="lead-add-field">
                <label htmlFor="custName" className="lead-add-label">
                  Lead Name <span className="lead-add-required">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Lead Full Name"
                  className={`lead-add-input ${
                    formErrors?.custName ? "lead-add-error" : ""
                  }`}
                  name="custName"
                  value={formValues.custName}
                  onChange={onChangeInput}
                  disabled={isRawLead}
                  ref={assignRef("custName")}
                />
              </div>

              <div className="lead-add-field">
                <label htmlFor="custEmail" className="lead-add-label">
                  Lead Email{" "}
                  <span className="lead-add-optional">(Optional)</span>
                </label>
                <input
                  type="email"
                  placeholder="Enter Lead Email Address"
                  className={`lead-add-input ${
                    formErrors?.custEmail ? "lead-add-error" : ""
                  }`}
                  name="custEmail"
                  value={formValues.custEmail}
                  onChange={onChangeInput}
                  disabled={isRawLead || (isWalkin && rowData?.email)}
                />
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_form" ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Lead Details</h3>
              <p className="lead-add-section-desc">
                Source, intent, and follow-up information
              </p>
            </div>
            <div className="lead-add-grid">
              <div className="lead-add-field">
                <label htmlFor="selectedSource" className="lead-add-label">
                  Source Name <span className="lead-add-required">*</span>{" "}
                </label>
                <div
                  className={`lead-add-dropdown-wrapper ${
                    formErrors.selectedSource ? "lead-add-error" : ""
                  } ${isSourceNameNotRequired ? "lead-add-disabled" : ""}`}
                  ref={assignRef("selectedSource")}
                >
                  <SelectDropdown
                    options={
                      (dynamic_lead_sources?.data?.length > 0
                        ? dynamic_lead_sources.data?.filter(
                            (option) => option?.value !== "wtf_one_day_plan"
                          )
                        : leadSources
                      )?.filter(s => !["Pre Sale", "Inbound Ads Call", "Website Referral", "Cold Calling", "IVR", "Company Leads", "WTF 360"].includes(s.label))
                    }
                    selectedOption={formValues.selectedSource}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedSource", selectedValue)
                    }
                    name="Source"
                    isDisable={isSourceNameNotRequired}
                  />
                </div>
              </div>

              <div className="lead-add-field">
                <label htmlFor="selCustomerIntent" className="lead-add-label">
                  Lead Intent <span className="lead-add-required">*</span>
                </label>

                <div
                  className={`lead-add-dropdown-wrapper ${
                    formErrors.selCustomerIntent ? "lead-add-error" : ""
                  } 
                  `}
                  // ${isCustomerIntentNotRequired ? "lead-add-disabled" : ""}
                  ref={assignRef("selCustomerIntent")}
                >
                  <SelectDropdown
                    options={customerIntents}
                    selectedOption={formValues.selCustomerIntent}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selCustomerIntent", selectedValue)
                    }
                    name="Lead Intent"
                    preventKeyboardOpen={true}
                    // isDisable={isCustomerIntentNotRequired}
                  />
                </div>
              </div>

              {formValues.selCustomerIntent ? (
                <>
                  <div className="lead-add-field">
                    <label
                      htmlFor="selectedFirstFollowupStatus"
                      className="lead-add-label"
                    >
                      First Followup Status{" "}
                      <span className="lead-add-required">*</span>
                    </label>
                    <div
                      className={`lead-add-dropdown-wrapper ${
                        formErrors.selectedFirstFollowupStatus
                          ? "lead-add-error"
                          : ""
                      } ${
                        isFirstFollowupstatusNotRequired
                          ? "lead-add-disabled"
                          : ""
                      }`}
                      ref={assignRef("selectedFirstFollowupStatus")}
                    >
                      <SelectDropdown
                        options={followupStatus?.filter(s => !["BTL Activity", "Walk in Scheduled"].includes(s.label))}
                        selectedOption={formValues.selectedFirstFollowupStatus}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(
                            "selectedFirstFollowupStatus",
                            selectedValue
                          )
                        }
                        name="First Followup Status"
                        preventKeyboardOpen={true}
                        isDisable={isFirstFollowupstatusNotRequired}
                      />
                    </div>
                  </div>

                  <div className="lead-add-field">
                    <label
                      htmlFor="nextFollofirstFollowupDatewupDate"
                      className="lead-add-label"
                    >
                      First Followup Date/Time{" "}
                      <span className="lead-add-required">*</span>
                    </label>
                    <div className="lead-add-two-input">
                      <input
                        type="text"
                        className="lead-add-input"
                        name="firstFollowupDate"
                        placeholder={`🚫 ${
                          formValues.firstFollowupDate || "NA"
                        }`}
                        disabled
                      />
                      <div
                        className={`lead-add-dropdown-wrapper lead-add-disabled ${
                          formErrors.firstFollowupTime ? "lead-add-error" : ""
                        } ${isRawLead ? "lead-add-disabled" : ""}`}
                      >
                        <SelectDropdownLabel
                          options={getCurrentTimeOption()}
                          selectedOption={formValues.firstFollowupTime}
                          setSelectedOption={(selectedValue) =>
                            onChangeDropdown("firstFollowupTime", selectedValue)
                          }
                          name="Time"
                          preventKeyboardOpen={true}
                          isDisable={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {formValues.selCustomerIntent && is_Next_Followup_Required_Raw ? (
                <>
                  <div className="lead-add-field">
                    <label
                      htmlFor="nextFollowupDate"
                      className="lead-add-label"
                    >
                      Next Followup Date/Time{" "}
                      {is_Next_Followup_Required_Raw ? (
                        <span className="lead-add-required">*</span>
                      ) : null}
                    </label>
                    <div className="lead-add-two-input">
                      <input
                        type="date"
                        className={`lead-add-input ${
                          formValues.nextFollowupDate ? "date-has-value" : ""
                        } ${
                          formErrors?.nextFollowupDate ? "lead-add-error" : ""
                        }`}
                        name="nextFollowupDate"
                        value={formValues.nextFollowupDate}
                        onChange={onChangeInput}
                        min={currentMonthCurrentDate}
                        ref={assignRef("nextFollowupDate")}
                      />
                      <div
                        className={`lead-add-dropdown-wrapper ${
                          formErrors.nextFollowupTime ? "lead-add-error" : ""
                        }`}
                        ref={assignRef("nextFollowupTime")}
                      >
                        <SelectDropdownLabel
                          options={timesOption.nextFollowupTimeOptions}
                          selectedOption={formValues.nextFollowupTime}
                          setSelectedOption={(selectedValue) =>
                            onChangeDropdown("nextFollowupTime", selectedValue)
                          }
                          name="Time"
                          preventKeyboardOpen={true}
                        />
                      </div>
                    </div>
                    {formValues.nextFollowupDate &&
                    timesOption.nextFollowupTimeOptions?.length === 0 ? (
                      <span className="lead-add-info">{`Followup time for ${convertStraight(
                        formValues.nextFollowupDate
                      )} is exceed, select different date`}</span>
                    ) : null}
                  </div>
                </>
              ) : null}

              {formValues.selCustomerIntent ? (
                <>
                  {is_Plan_Info_Required || isRawLead ? (
                    <>
                      <div className="lead-add-field">
                        <label
                          htmlFor="selectedPlan"
                          className="lead-add-label"
                        >
                          Plan{" "}
                          {is_Plan_Info_Required ? (
                            <span className="lead-add-required">*</span>
                          ) : null}
                        </label>
                        <div
                          className={`lead-add-dropdown-wrapper ${
                            formErrors.selectedPlan ? "lead-add-error" : ""
                          } ${isRawLead ? "lead-add-disabled" : ""}`}
                          ref={assignRef("selectedPlan")}
                        >
                          <SelectDropdown
                            options={leadPlanTypes}
                            selectedOption={formValues.selectedPlan}
                            setSelectedOption={(selectedValue) =>
                              onChangeDropdown("selectedPlan", selectedValue)
                            }
                            name="Plan"
                            preventKeyboardOpen={true}
                            isDisable={isRawLead}
                          />
                        </div>
                      </div>

                      <div className="lead-add-field">
                        <label
                          htmlFor="leadValueAmount"
                          className="lead-add-label"
                        >
                          Lead Value{" "}
                          {is_Plan_Info_Required ? (
                            <span className="lead-add-required">*</span>
                          ) : null}
                        </label>
                        <input
                          type="number"
                          placeholder="Enter Amount"
                          className={`lead-add-input ${
                            formErrors?.leadValueAmount ? "lead-add-error" : ""
                          }`}
                          name="leadValueAmount"
                          value={formValues.leadValueAmount}
                          onChange={onChangeInput}
                          min={0}
                          ref={assignRef("leadValueAmount")}
                        />
                      </div>
                    </>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_form" ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Gym & Assignment</h3>
              <p className="lead-add-section-desc">
                Gym selection and assignment options
              </p>
            </div>
            <div className="lead-add-grid">
              {!isRawLead && formValues.selCustomerIntent ? (
                <div className="lead-add-field">
                  <label
                    htmlFor="selectedGym"
                    className="lead-add-label"
                    ref={assignRef("selectedGym")}
                  >
                    Gym{" "}
                    {isAdmin && <span className="lead-add-required">*</span>}
                  </label>

                  {!formValues.isAssignDifferentReceptionist &&
                  !formValues.isSelfAssign ? (
                    <input
                      type="text"
                      className="lead-add-input"
                      name="selectedGym"
                      placeholder={`🚫 ${formValues.defaultGym?.label || "NA"}`}
                      disabled
                    />
                  ) : (
                    <div
                      className={`lead-add-dropdown-wrapper ${
                        formErrors.selectedGym ? "lead-add-error" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={gymData?.length > 0 ? gymData : []}
                        selectedOption={formValues.selectedGym}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("selectedGym", selectedValue)
                        }
                        name="Gym"
                      />
                    </div>
                  )}

                  <div className="lead-add-checkbox-group">
                    <Form.Check
                      type="checkbox"
                      name="isAssignDifferentReceptionist"
                      className={`lead-add-checkbox ${
                        formErrors?.isAssignDifferentReceptionist
                          ? "lead-add-error"
                          : ""
                      }`}
                      label={`${
                        formValues.isAssignDifferentReceptionist
                          ? "FD Available Based On The Next Followup Time"
                          : "Assign To Different Gym"
                      }`}
                      checked={formValues.isAssignDifferentReceptionist}
                      onChange={onChangeInput}
                    />

                    {isAdmin ? (
                      <Form.Check
                        type="checkbox"
                        name="isSelfAssign"
                        className={`lead-add-checkbox ${
                          formErrors?.isSelfAssign ? "lead-add-error" : ""
                        }`}
                        label="Assign To My Self"
                        checked={formValues.isSelfAssign}
                        onChange={onChangeInput}
                      />
                    ) : null}
                  </div>
                </div>
              ) : null}

              {formValues.selCustomerIntent &&
              formValues.isAssignDifferentReceptionist &&
              formValues.selectedGym ? (
                <>
                  <div className="lead-add-field">
                    <label
                      htmlFor="selectedReceptionist"
                      className="lead-add-label"
                    >
                      FD <span className="lead-add-required">*</span>
                    </label>
                    <div
                      className={`lead-add-dropdown-wrapper ${
                        formErrors.selectedReceptionist ? "lead-add-error" : ""
                      }`}
                      ref={assignRef("selectedReceptionist")}
                    >
                      <SelectDropdown
                        options={
                          receptionistBySlot?.length > 0
                            ? receptionistBySlot
                            : []
                        }
                        selectedOption={formValues.selectedReceptionist}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(
                            "selectedReceptionist",
                            selectedValue
                          )
                        }
                        name="FD"
                      />
                    </div>
                    {formValues.isAssignDifferentReceptionist &&
                    receptionistBySlot?.length === 0 ? (
                      <span className="lead-add-info">{`No FD Is Available In The Shift Time - ${
                        formValues.nextFollowupTime?.label || ""
                      }`}</span>
                    ) : null}
                  </div>
                </>
              ) : null}
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_form" && formValues.selCustomerIntent ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Follow-up Details</h3>
              <p className="lead-add-section-desc">
                Detailed information about the first follow-up
              </p>
            </div>
            <div className="lead-add-grid">
              <div className="lead-add-field" style={{ gridColumn: "1 / -1" }}>
                <label
                  htmlFor="firstFollowupDetails"
                  className="lead-add-label"
                >
                  First Followup Details (Min 20 Characters -{" "}
                  {formValues.firstFollowupDetails?.length || 0}){" "}
                  <span className="lead-add-required">*</span>
                </label>
                <textarea
                  name="firstFollowupDetails"
                  className={`lead-add-input ${
                    formErrors.firstFollowupDetails ? "lead-add-error" : ""
                  }`}
                  placeholder="Brief About First Followup"
                  value={formValues.firstFollowupDetails}
                  onChange={onChangeInput}
                  ref={assignRef("firstFollowupDetails")}
                  rows={4}
                  style={{ resize: "vertical", minHeight: "120px" }}
                ></textarea>
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_followup_form" ? (
          <div className="lead-add-section">
            <div className="lead-add-section-header">
              <h3 className="lead-add-section-title">Add Follow-up Details</h3>
              <p className="lead-add-section-desc">
                Add follow-up information for the transferred lead
              </p>
            </div>
            <div className="lead-add-grid">
              <div className="lead-add-field">
                <label htmlFor="selCustomerIntent" className="lead-add-label">
                  Lead Intent <span className="lead-add-required">*</span>
                </label>
                <div
                  className={`lead-add-dropdown-wrapper ${
                    formErrors.selCustomerIntent ? "lead-add-error" : ""
                  }`}
                  ref={assignRef("selCustomerIntent")}
                >
                  <SelectDropdown
                    options={customerIntents}
                    selectedOption={formValues.selCustomerIntent}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selCustomerIntent", selectedValue)
                    }
                    name="Lead Intent"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>

              {formValues.selCustomerIntent ? (
                <div className="lead-add-field">
                  <label
                    htmlFor="selectedFirstFollowupStatus"
                    className="lead-add-label"
                  >
                    First Followup Status{" "}
                    <span className="lead-add-required">*</span>
                  </label>
                  <div
                    className={`lead-add-dropdown-wrapper ${
                      formErrors.selectedFirstFollowupStatus
                        ? "lead-add-error"
                        : ""
                    }`}
                    ref={assignRef("selectedFirstFollowupStatus")}
                  >
                    <SelectDropdown
                      options={followupStatus?.filter(s => !["BTL Activity", "Walk in Scheduled"].includes(s.label))}
                      selectedOption={formValues.selectedFirstFollowupStatus}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(
                          "selectedFirstFollowupStatus",
                          selectedValue
                        )
                      }
                      name="First Followup Status"
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              ) : null}

              {formValues.selCustomerIntent ? (
                <div className="lead-add-field">
                  <label htmlFor="firstFollowupDate" className="lead-add-label">
                    First Followup Date/Time{" "}
                    <span className="lead-add-required">*</span>
                  </label>
                  <div className="lead-add-two-input">
                    <input
                      type="text"
                      className="lead-add-input"
                      name="firstFollowupDate"
                      placeholder={`🚫 ${
                        formValues.firstFollowupDate || "Today"
                      }`}
                      disabled
                    />
                    <div
                      className={`lead-add-dropdown-wrapper ${
                        formErrors.firstFollowupTime ? "lead-add-error" : ""
                      }`}
                      ref={assignRef("firstFollowupTime")}
                    >
                      <SelectDropdownLabel
                        options={getCurrentTimeOption()}
                        selectedOption={formValues.firstFollowupTime}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("firstFollowupTime", selectedValue)
                        }
                        name="Time"
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>
                </div>
              ) : null}

              {formValues.selCustomerIntent &&
              formValues.selectedFirstFollowupStatus?.next_followup_required ? (
                <div className="lead-add-field">
                  <label htmlFor="nextFollowupDate" className="lead-add-label">
                    Next Followup Date/Time{" "}
                    <span className="lead-add-required">*</span>
                  </label>
                  <div className="lead-add-two-input">
                    <input
                      type="date"
                      className={`lead-add-input ${
                        formValues.nextFollowupDate ? "date-has-value" : ""
                      } ${
                        formErrors?.nextFollowupDate ? "lead-add-error" : ""
                      }`}
                      name="nextFollowupDate"
                      value={formValues.nextFollowupDate}
                      onChange={onChangeInput}
                      min={currentMonthCurrentDate}
                      ref={assignRef("nextFollowupDate")}
                    />
                    <div
                      className={`lead-add-dropdown-wrapper ${
                        formErrors.nextFollowupTime ? "lead-add-error" : ""
                      }`}
                      ref={assignRef("nextFollowupTime")}
                    >
                      <SelectDropdownLabel
                        options={timesOption.nextFollowupTimeOptions}
                        selectedOption={formValues.nextFollowupTime}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("nextFollowupTime", selectedValue)
                        }
                        name="Time"
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>
                  {formValues.nextFollowupDate &&
                  timesOption.nextFollowupTimeOptions?.length === 0 ? (
                    <span className="lead-add-info">{`Followup time for ${convertStraight(
                      formValues.nextFollowupDate
                    )} is exceed, select different date`}</span>
                  ) : null}
                </div>
              ) : null}

              {formValues.selectedFirstFollowupStatus?.price_required ? (
                <>
                  <div className="lead-add-field">
                    <label htmlFor="selectedPlan" className="lead-add-label">
                      Plan <span className="lead-add-required">*</span>
                    </label>
                    <div
                      className={`lead-add-dropdown-wrapper ${
                        formErrors.selectedPlan ? "lead-add-error" : ""
                      }`}
                      ref={assignRef("selectedPlan")}
                    >
                      <SelectDropdown
                        options={leadPlanTypes}
                        selectedOption={formValues.selectedPlan}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("selectedPlan", selectedValue)
                        }
                        name="Plan"
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>

                  <div className="lead-add-field">
                    <label htmlFor="leadValueAmount" className="lead-add-label">
                      Lead Value <span className="lead-add-required">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Enter Amount"
                      className={`lead-add-input ${
                        formErrors?.leadValueAmount ? "lead-add-error" : ""
                      }`}
                      name="leadValueAmount"
                      value={formValues.leadValueAmount}
                      onChange={onChangeInput}
                      min={0}
                      ref={assignRef("leadValueAmount")}
                    />
                  </div>
                </>
              ) : null}

              <div className="lead-add-field" style={{ gridColumn: "1 / -1" }}>
                <label
                  htmlFor="firstFollowupDetails"
                  className="lead-add-label"
                >
                  First Followup Details (Min 20 Characters -{" "}
                  {formValues.firstFollowupDetails?.length || 0}){" "}
                  <span className="lead-add-required">*</span>
                </label>
                <textarea
                  name="firstFollowupDetails"
                  className={`lead-add-input ${
                    formErrors.firstFollowupDetails ? "lead-add-error" : ""
                  }`}
                  placeholder="Brief About First Followup"
                  value={formValues.firstFollowupDetails}
                  onChange={onChangeInput}
                  ref={assignRef("firstFollowupDetails")}
                  rows={4}
                  style={{ resize: "vertical", minHeight: "120px" }}
                ></textarea>
              </div>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_form" ||
        leadLookupStep === "show_followup_form" ? (
          <div className="lead-add-section lead-add-submit-section">
            <div
              className="formButtons"
              style={{ justifyContent: "flex-end", display: "flex", gap: 16 }}
            >
              <Button
                className="cancelBtn"
                variant="outline-dark"
                onClick={closeModal}
              >
                Cancel
              </Button>
              <Button
                className="saveBtn"
                variant="danger"
                onClick={onSumitForm}
              >
                {postPutLoading ? <ReactVortoxSpinner /> : "Submit"}
              </Button>
            </div>
          </div>
        ) : null}

        {leadLookupStep === "show_converted" ||
        leadLookupStep === "show_existing" ? (
          <div className="lead-add-section lead-add-submit-section">
            <div
              className="formButtons"
              style={{ justifyContent: "center", display: "flex", gap: 16 }}
            >
              <Button
                className="lead-add-secondary-btn"
                variant="outline-primary"
                onClick={handleTryDifferentNumber}
              >
                Try Different Number
              </Button>
              <Button
                className="lead-add-reopen-btn"
                // variant="outline-success"
                onClick={handleReopenLead}
              >
                Reopen Lead
              </Button>
              <Button
                className="cancelBtn"
                variant="outline-dark"
                onClick={closeModal}
              >
                Close
              </Button>
            </div>
          </div>
        ) : null}
      </form>
    </div>
  );
};

export default AddLeadForm;
